export enum TerrorZone {
  // Act I
  BLOOD_MOOR = 'BLOOD_MOOR',
  COLD_PLAINS = 'COLD_PLAINS',
  BURIAL_GROUNDS = 'BURIAL_GROUNDS',
  STONY_FIELD = 'STONY_FIELD',
  DARK_WOOD = 'DARK_WOOD',
  BLACK_MARSH = 'BLACK_MARSH',
  FORGOTTEN_TOWER = 'FORGOTTEN_TOWER',
  JAIL = 'JAIL',
  CATACOMBS = 'CATACOMBS',
  PIT = 'PIT',
  TRISTRAM = 'TRISTRAM',
  COWS = 'COWS',
  // Act II
  SEWERS = 'SEWERS',
  ROCKY_WASTE = 'ROCKY_WASTE',
  DRY_HILLS = 'DRY_HILLS',
  FAR_OASIS = 'FAR_OASIS',
  LOST_CITY = 'LOST_CITY',
  ANCIENT_TUNNELS = 'ANCIENT_TUNNELS',
  ARCANE_SANCTUARY = 'ARCANE_SANCTUARY',
  TOMBS = 'TOMBS',
    // Act III
  SPIDER_FOREST = 'SPIDER_FOREST',
  GREAT_MARSH = 'GREAT_MARSH',
  FLAYER_JUNGLE = 'FLAYER_JUNGLE',
  KURAST_BAZAAR = 'KURAST_BAZAAR',
  KURAST_SEWERS = 'KURAST_SEWERS',
  TRAVINCAL = 'TRAVINCAL',
  DURANCE_OF_HATE = 'DURANCE_OF_HATE',
  // Act IV
  OUTER_STEPPES = 'OUTER_STEPPES',
  RIVER_OF_FLAME = 'RIVER_OF_FLAME',
  CHAOS_SANCTUARY = 'CHAOS_SANCTUARY',
  // Act V
  BLOODY_FOOTHILLS = 'BLOODY_FOOTHILLS',
  FRIGID_HIGHLANDS = 'FRIGID_HIGHLANDS',
  GLACIAL_TRAIL = 'GLACIAL_TRAIL',
  CRYSTALLINE_PASSAGE = 'CRYSTALLINE_PASSAGE',
  ARREAT_PLATEAU = 'ARREAT_PLATEAU',
  NIHLATHAK = 'NIHLATHAK',
  ANCIENTS_WAY = 'ANCIENTS_WAY',
  WORLDSTONE_KEEP = 'WORLDSTONE_KEEP',
}

export const ZoneIdMapping: Record<TerrorZone, Array<number>> = {
  BLOOD_MOOR: [2, 8],
  COLD_PLAINS: [3, 9, 13],
  BURIAL_GROUNDS: [17, 18, 19],
  STONY_FIELD: [4],
  DARK_WOOD: [5, 10, 14],
  BLACK_MARSH: [6, 11, 15],
  FORGOTTEN_TOWER: [21, 22, 23, 24, 25],
  JAIL: [28, 29, 30, 31],
  CATACOMBS: [33, 34, 35, 36],
  PIT: [12, 16],
  TRISTRAM: [38],
  COWS: [39],
  SEWERS: [47, 48, 49],
  ROCKY_WASTE: [41, 55, 59],
  DRY_HILLS: [42, 56, 57, 60],
  FAR_OASIS: [43],
  LOST_CITY: [44, 45, 58, 61],
  ANCIENT_TUNNELS: [65],
  ARCANE_SANCTUARY: [74],
  TOMBS: [66, 67, 68, 69, 70, 71, 72, 73],
  SPIDER_FOREST: [76, 85],
  GREAT_MARSH: [77],
  FLAYER_JUNGLE: [78, 88, 89, 91],
  KURAST_BAZAAR: [80, 94, 95],
  TRAVINCAL: [83],
  DURANCE_OF_HATE: [100, 101, 102],
  OUTER_STEPPES: [104, 105],
  RIVER_OF_FLAME: [106, 107],
  CHAOS_SANCTUARY: [108],
  BLOODY_FOOTHILLS: [110, 111, 125],
  GLACIAL_TRAIL: [115, 116],
  CRYSTALLINE_PASSAGE: [113, 114],
  ARREAT_PLATEAU: [112, 126],
  NIHLATHAK: [121, 122, 123, 124],
  ANCIENTS_WAY: [118, 119],
  WORLDSTONE_KEEP: [128, 129, 130, 131],
  KURAST_SEWERS: [],
  FRIGID_HIGHLANDS: []
}

export const generateTZLabel = (tz: TerrorZone): string => {
  const zones = ZoneIdMapping[tz];
  if (zones.length == 0) {
    throw new Error('Invalid zone');
  }
  if (zones.length == 1) {
    return ZonesById[zones[0]];
  }
  let output = '';
  let i = 0;
  while (i < zones.length - 2) {
    output += (ZonesById[zones[i]] + ',');
    i++
  }
  output += (ZonesById[zones[i]] + ' and ' + ZonesById[zones[i + 1]]);
  return output;
}

export const ZonesById: Record<number, string> = {
  2: 'Blood Moor',
  3: 'Cold Plains',
  4: 'Stony Field',
  5: 'Dark Wood', 
  6: 'Black Marsh',
  7: 'Tamoe Highland',
  8: 'Den of Evil',
  9: 'Cave Level 1',
  10: 'Underground Passage Level 1',
  11: 'Hole Level 1',
  12: 'Pit Level 1',
  13: 'Cave Level 2',
  14: 'Underground Passage Level 2',
  15: 'Hole Level 2',
  16: 'Pit Level 2',
  17: 'Burial Grounds',
  18: 'Crypt',
  19: 'Mausoleum',
  20: 'Forgotten Tower',
  21: 'Tower Cellar Level 1',
  22: 'Tower Cellar Level 2',
  23: 'Tower Cellar Level 3',
  24: 'Tower Cellar Level 4',
  25: 'Tower Cellar Level 5',
  26: 'Monastery Gate',
  27: 'Outer Cloister',
  28: 'Barracks',
  29: 'Jail Level 1',
  30: 'Jail Level 2',
  31: 'Jail Level 3',
  32: 'Inner Cloister',
  33: 'Cathedral',
  34: 'Catacombs Level 1',
  35: 'Catacombs Level 2',
  36: 'Catacombs Level 3',
  37: 'Catacombs Level 4',
  38: 'Tristram',
  39: 'Moo Moo Farm',
  40: 'Lut Gholein',
  41: 'Rocky Waste',
  42: 'Dry Hills',
  43: 'Far Oasis',
  44: 'Lost City',
  45: 'Valley of Snakes',
  46: 'Canyon of the Magi',
  47: 'Sewers Level 1',
  48: 'Sewers Level 2',
  49: 'Sewers Level 3',
  50: 'Harem Level 1',
  51: 'Harem Level 2',
  52: 'Palace Cellar Level 1',
  53: 'Palace Cellar Level 2',
  54: 'Palace Cellar Level 3',
  55: 'Stony Tomb Level 1',
  56: 'Halls of the Dead Level 1',
  57: 'Halls of the Dead Level 2',
  58: 'Claw Viper Temple Level 1',
  59: 'Stony Tomb Level 2',
  60: 'Halls of the Dead Level 3',
  61: 'Claw Viper Temple Level 2',
  62: 'Maggot Lair Level 1',
  63: 'Maggot Lair Level 2',
  64: 'Maggot Lair Level 3',
  65: 'Ancient Tunnels',
  66: 'Tal Rasha\'s Tomb',
  67: 'Tal Rasha\'s Tomb',
  68: 'Tal Rasha\'s Tomb',
  69: 'Tal Rasha\'s Tomb',
  70: 'Tal Rasha\'s Tomb',
  71: 'Tal Rasha\'s Tomb',
  72: 'Tal Rasha\'s Tomb',
  73: 'Duriel\'s Lair',
  74: 'Arcane Sanctuary',
  75: 'Kurast Docktown',
  76: 'Spider Forest',
  77: 'Great Marsh',
  78: 'Flayer Jungle',
  79: 'Lower Kurast',
  80: 'Kurast Bazaar',
  81: 'Upper Kurast',
  82: 'Kurast Causeway',
  83: 'Travincal',
  84: 'Arachnid Lair',
  85: 'Spider Cavern',
  86: 'Swampy Pit Level 1',
  87: 'Swampy Pit Level 2',
  88: 'Flayer Dungeon Level 1',
  89: 'Flayer Dungeon Level 2',
  90: 'Swampy Pit Level 3',
  91: 'Flayer Dungeon Level 3',
  92: 'Sewers Level 1',
  93: 'Sewers Level 2',
  94: 'Ruined Temple',
  95: 'Disused Fane',
  96: 'Forgotten Reliquary',
  97: 'Forgotten Temple',
  98: 'Ruined Fane',
  99: 'Disused Reliquary',
  100: 'Durance of Hate Level 1',
  101: 'Durance of Hate Level 2',
  102: 'Durance of Hate Level 3',
  103: 'The Pandemonium Fortress',
  104: 'Outer Steppes',
  105: 'Plains of Despair',
  106: 'City of the Damned',
  107: 'River of Flame',
  108: 'The Chaos Sanctuary',
  109: 'Harrogath',
  110: 'Bloody Foothills',
  111: 'Frigid Highlands',
  112: 'Arreat Plateau',
  113: 'Crystalline Passage',
  114: 'Frozen River',
  115: 'Glacial Trail',
  116: 'Drifter Cavern',
  117: 'Frozen Tundra',
  118: 'The Ancients\' Way',
  119: 'Icy Cellar',
  120: 'Arreat Summit',
  121: 'Nihlathak\'s Temple',
  122: 'Halls of Anguish',
  123: 'Halls of Pain',
  124: 'Halls of Vaught',
  125: 'Abaddon',
  126: 'Pit of Acheron',
  127: 'Infernal Pit',
  128: 'The Worldstone Keep Level 1',
  129: 'The Worldstone Keep Level 2',
  130: 'The Worldstone Keep Level 3',
  131: 'Throne of Destruction',
  132: 'The Worldstone Chamber',
}

export const TerrorZoneLabels: Record<keyof typeof TerrorZone, string> = {
  // Act I
  [TerrorZone.BLOOD_MOOR]: generateTZLabel(TerrorZone.BLOOD_MOOR),
  [TerrorZone.COLD_PLAINS]: generateTZLabel(TerrorZone.COLD_PLAINS),
  [TerrorZone.BURIAL_GROUNDS]: generateTZLabel(TerrorZone.BURIAL_GROUNDS),
  [TerrorZone.STONY_FIELD]: generateTZLabel(TerrorZone.STONY_FIELD),
  [TerrorZone.DARK_WOOD]: 'Dark Wood and Underground Passage',
  [TerrorZone.BLACK_MARSH]: generateTZLabel(TerrorZone.BLACK_MARSH),
  [TerrorZone.FORGOTTEN_TOWER]: 'The Forgotten Tower',
  [TerrorZone.JAIL]: 'Jail and Barracks',
  [TerrorZone.CATACOMBS]: 'Cathedral and Catacombs',
  [TerrorZone.PIT]: 'The Pit',
  [TerrorZone.TRISTRAM]: generateTZLabel(TerrorZone.TRISTRAM),
  [TerrorZone.COWS]: generateTZLabel(TerrorZone.COWS),
  // Act II
  [TerrorZone.SEWERS]: 'Lut Gholein Sewers (Act II)',
  [TerrorZone.ROCKY_WASTE]: 'Rocky Waste and Stony Tomb',
  [TerrorZone.DRY_HILLS]: 'Dry Hills and Halls of the Dead',
  [TerrorZone.FAR_OASIS]: generateTZLabel(TerrorZone.FAR_OASIS),
  [TerrorZone.LOST_CITY]: 'Lost City, Valley of Snakes, and Claw Viper Temple',
  [TerrorZone.ANCIENT_TUNNELS]: generateTZLabel(TerrorZone.ANCIENT_TUNNELS),
  [TerrorZone.ARCANE_SANCTUARY]: generateTZLabel(TerrorZone.ARCANE_SANCTUARY),
  [TerrorZone.TOMBS]: 'Tal Rasha\'s Tombs',
  // Act III
  [TerrorZone.SPIDER_FOREST]: 'Spider Forest and Spider Cavern',
  [TerrorZone.GREAT_MARSH]: generateTZLabel(TerrorZone.GREAT_MARSH),
  [TerrorZone.FLAYER_JUNGLE]: 'Flayer Jungle and Flayer Dungeon',
  [TerrorZone.KURAST_BAZAAR]: generateTZLabel(TerrorZone.KURAST_BAZAAR),
  [TerrorZone.KURAST_SEWERS]: '(INACTIVE) Kurast Sewers (Act III)',
  [TerrorZone.TRAVINCAL]: generateTZLabel(TerrorZone.TRAVINCAL),
  [TerrorZone.DURANCE_OF_HATE]: 'Durance of Hate',
  // Act IV
  [TerrorZone.OUTER_STEPPES]: generateTZLabel(TerrorZone.OUTER_STEPPES),
  [TerrorZone.RIVER_OF_FLAME]: generateTZLabel(TerrorZone.RIVER_OF_FLAME),
  [TerrorZone.CHAOS_SANCTUARY]: generateTZLabel(TerrorZone.CHAOS_SANCTUARY),
  // Act V
  [TerrorZone.BLOODY_FOOTHILLS]: generateTZLabel(TerrorZone.BLOODY_FOOTHILLS),
  [TerrorZone.FRIGID_HIGHLANDS]: '(INACTIVE) Frigid Highlands',
  [TerrorZone.GLACIAL_TRAIL]: generateTZLabel(TerrorZone.GLACIAL_TRAIL),
  [TerrorZone.CRYSTALLINE_PASSAGE]: generateTZLabel(TerrorZone.CRYSTALLINE_PASSAGE),
  [TerrorZone.ARREAT_PLATEAU]: generateTZLabel(TerrorZone.ARREAT_PLATEAU),
  [TerrorZone.NIHLATHAK]: generateTZLabel(TerrorZone.NIHLATHAK),
  [TerrorZone.ANCIENTS_WAY]: generateTZLabel(TerrorZone.ANCIENTS_WAY),
  [TerrorZone.WORLDSTONE_KEEP]: 'Worldstone Keep, Throne of Destruction, and Worldstone Chamber',
}

export const TerrorZoneList: Array<TerrorZone> = Object.keys(TerrorZoneLabels) as Array<TerrorZone>;
export const TerrorZoneListAct1 = TerrorZoneList.slice(0, 12);
export const TerrorZoneListAct2 = TerrorZoneList.slice(12, 20);
export const TerrorZoneListAct3 = TerrorZoneList.slice(20, 27);
export const TerrorZoneListAct4 = TerrorZoneList.slice(27, 30);
export const TerrorZoneListAct5 = TerrorZoneList.slice(30, 38);

export const ActiveTerrorZones: TerrorZone[] = [
  // Act I
  TerrorZone.BLOOD_MOOR,
  TerrorZone.COLD_PLAINS,
  TerrorZone.BURIAL_GROUNDS,
  TerrorZone.STONY_FIELD,
  TerrorZone.DARK_WOOD,
  TerrorZone.BLACK_MARSH,
  TerrorZone.FORGOTTEN_TOWER,
  TerrorZone.JAIL,
  TerrorZone.CATACOMBS,
  TerrorZone.PIT,
  TerrorZone.TRISTRAM,
  TerrorZone.COWS,
  // Act II
  TerrorZone.SEWERS,
  TerrorZone.ROCKY_WASTE,
  TerrorZone.DRY_HILLS,
  TerrorZone.FAR_OASIS,
  TerrorZone.LOST_CITY,
  TerrorZone.ANCIENT_TUNNELS,
  TerrorZone.ARCANE_SANCTUARY,
  TerrorZone.TOMBS,
  // Act III
  TerrorZone.SPIDER_FOREST,
  TerrorZone.GREAT_MARSH,
  TerrorZone.FLAYER_JUNGLE,
  TerrorZone.KURAST_BAZAAR,
  TerrorZone.TRAVINCAL,
  TerrorZone.DURANCE_OF_HATE,
  // Act IV
  TerrorZone.OUTER_STEPPES,
  TerrorZone.RIVER_OF_FLAME,
  TerrorZone.CHAOS_SANCTUARY,
  // Act V
  TerrorZone.BLOODY_FOOTHILLS,
  TerrorZone.GLACIAL_TRAIL,
  TerrorZone.CRYSTALLINE_PASSAGE,
  TerrorZone.ARREAT_PLATEAU,
  TerrorZone.NIHLATHAK,
  TerrorZone.ANCIENTS_WAY,
  TerrorZone.WORLDSTONE_KEEP,
]